import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/unsubscribe",
    name: "unsubscribe",
    component: () =>
      import(
        /* webpackChunkName: "unsubscribe" */ "../views/UnsubscribeView.vue"
      ),
  },
  {
    path: "/vote",
    name: "vote",
    component: () =>
      import(/* webpackChunkName: "vote" */ "../views/VoteView.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
